import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file 异步加载state
 * @author alfielv
 */
import _ from 'lodash';
import { useEffect, useCallback, useRef, useReducer } from 'react';
import message from '../../components/Message';
import useOriginReference from '../useOriginReference';

var reducer = function reducer(state, action) {
  switch (action.type) {
    case 'REQUEST':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          status: 'fetching',
          fetching: true,
          error: null
        });
      }

    case 'RESPONSE_SUCCESS':
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          status: 'success',
          fetching: false,
          data: action.payload.data,
          error: null
        });
      }

    case 'RESPONSE_ERROR':
      return _objectSpread(_objectSpread({}, state), {}, {
        status: 'error',
        fetching: false,
        data: null,
        error: action.payload.error
      });

    default:
      return state;
  }
};

export default (function (action, params, initialData) {
  var execute = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var $onRequest = arguments.length > 4 ? arguments[4] : undefined;
  var $onResponse = arguments.length > 5 ? arguments[5] : undefined;

  var _useReducer = useReducer(reducer, {
    status: 'init',
    data: initialData,
    fetching: false,
    error: null
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1]; // 组件卸载标识


  var cancelledRef = useRef(false); // 请求参数(相同值引用包装)

  var paramsOriginRef = useOriginReference(params); // 请求方法

  var doFetch = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var requestParams, resData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              type: 'REQUEST'
            });
            cancelledRef.current = false;
            _context.prev = 2;
            requestParams = _.isFunction($onRequest) ? $onRequest(paramsOriginRef) : paramsOriginRef;
            _context.next = 6;
            return action(requestParams);

          case 6:
            resData = _context.sent;

            if (_.isFunction($onResponse)) {
              resData = $onResponse(resData);
            }

            if (!cancelledRef.current) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return");

          case 10:
            dispatch({
              type: 'RESPONSE_SUCCESS',
              payload: {
                data: resData
              }
            });
            _context.next = 19;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](2);

            if (!cancelledRef.current) {
              _context.next = 17;
              break;
            }

            return _context.abrupt("return");

          case 17:
            dispatch({
              type: 'RESPONSE_ERROR',
              payload: {
                error: _context.t0
              }
            });
            message.error(_context.t0.message);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 13]]);
  })), [paramsOriginRef]);
  useEffect(function () {
    execute && doFetch();
    return function () {
      cancelledRef.current = true;
    };
  }, [execute, doFetch]);
  return _objectSpread(_objectSpread({}, state), {}, {
    doFetch: doFetch
  });
});